import React, { useEffect } from 'react'
import '../../../../node_modules/bootstrap-daterangepicker/daterangepicker.css'
import { Table } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { fetchNotificationyAsync } from './_redux/notificattion.api'
import { NotificationAction } from './_redux/notificattion.action'
import BasicPagination from '../pagination/BasicPagination'

function Notifications() {
  const dispatch = useDispatch()

  const {
    notificationList,
    notificationBatch,
    notificationLimit,
    isReloading,
  } = useSelector((state) => state.notification)

  useEffect(() => {
    dispatch(fetchNotificationyAsync(notificationBatch, notificationLimit))
  }, [notificationBatch])

  const onPageChange = (currentBatch) => {
    let dataCount = currentBatch ? currentBatch - 1 : notificationBatch
    dispatch(NotificationAction.setNotificationBatchNumber(dataCount))
  }

  const pageNumberDisplay = () => {
    const totalRecords = notificationList.recordsTotal
    const lowerBound = notificationBatch * notificationLimit + 1
    let upperBound = notificationBatch * notificationLimit + notificationLimit
    upperBound = upperBound > totalRecords ? totalRecords : upperBound

    return `${lowerBound} - ${upperBound} of ${totalRecords}`
  }

  const onMarkAsRead = () => {
    dispatch(fetchNotificationyAsync(notificationBatch, notificationLimit))
  }

  return (
    <div className="row">
      <div className="col-md-12 d-flex justify-content-between flex-wrap flex-sm-nowrap db_1400">
        <div className="mr-1">
          <h5 className="inpg_ttl mr-5">Notifications</h5>
        </div>
        <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
          
            {isReloading ? (
              <div className='spinner spinner-sm spinner-primary mr-6' style={{height: 19}}></div>
            ) : notificationList.records.some((item) => !item.isRead) ? (
                <button
                type="button"
                onClick={onMarkAsRead}
                className="btn btn-def btn-defv5 ml-auto"
              >Mark As Read</button>
            ) : (
              <span>
                <i
                onClick={onMarkAsRead}
                style={{ cursor: 'pointer' }}
                  className="fas fa-redo-alt ml-2"
                ></i>
              </span>
            )}
          
        </div>
      </div>

      <div className="col-md-12 mt-5">
        <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn">
          <div className="tblmrgn mt-0">
            <div className="row d-flex align-items-center mr-5 ml-5">
              <div className="col-md-4 mb-5 fn_s_16 f-w-400">
                Displaying {pageNumberDisplay()} Records
              </div>
              <div className="col-md-4 text-center mb-5 algnlft676"></div>
              <div className="col-md-4 text-right mb-5 aspgntn">
                <BasicPagination
                  totalRecords={notificationList.recordsTotal}
                  limit={notificationLimit}
                  batch={notificationBatch + 1}
                  onBatchChange={onPageChange}
                />
              </div>
            </div>
            <Table
              hover
              responsive
              className="mb-0 default_table with_hoverbtn mrpdng_tbl"
            >
              <thead>
                <tr>
                  <th>
                    {/* <div className="ap_checkbox tblckcbx">
                                            <input type="checkbox" name="checkbox" className="mr-2 checkbox" />
                                            <label></label>
                                        </div> */}
                  </th>
                  <th>Date and Time</th>
                  <th>Title</th>
                  <th>Detail</th>
                  <th className="wd-120"></th>
                </tr>
              </thead>
              <tbody>
                {notificationList.records.map((item, index) => (
                  <tr key={item._id}>
                    <td>
                      <div className="d-flex align-items-center">
                        {/* <div className="ap_checkbox tblckcbx">
                                                    <input type="checkbox" name="checkbox" className="mr-2 checkbox" />
                                                    <label></label>
                                                </div> */}
                        {!item.isRead ? (
                          <span className="tb_dots"></span>
                        ) : null}
                      </div>
                    </td>
                    <td>
                      {new Date(item.createdAt).getDate()}&nbsp;
                      {new Date(item.createdAt).toLocaleString('default', {
                        month: 'short',
                      })}
                      &nbsp;{new Date(item.createdAt).getFullYear()}{' '}
                      &nbsp;|&nbsp; {new Date(item.createdAt).getHours()} :{' '}
                      {new Date(item.createdAt).getMinutes()}
                    </td>
                    <td>
                      <span className="f-w-500">{item.categoryType}</span>
                    </td>
                    <td>{item.message}</td>
                    <td>
                      {/* <Link to="#" className="btn_new btn-sm dtld_btn">Details</Link> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      <div className="col-md-12"></div>
    </div>
  )
}

export default Notifications
